<template>
  <BlogArchive kind="category" />
</template>

<script>
import BlogArchive from './BlogArchive'

export default {
  name: 'BlogCategoryPosts',
  components: { BlogArchive }
}
</script>
